// extracted by mini-css-extract-plugin
export default {"wrapper":"htQQEK","section":"J8ND0k","section--xl":"D3Of6C","section--l":"WFsnZs","section--m":"V4XbYa","section--s":"HnMX3K"};